import IconDiscard from "../../icons/icon-discard/icon-discard";
import { ButtonIcon } from "../../inputs/button-icon/button-icon";
import { IShop } from "../../../models/User";
import ShopLabel from "../shop-label/shop-label";

interface ISelectedShopProps {
    shop: IShop;
    onUnselect: (shop: IShop) => void;
}

const SelectedShop: React.FC<ISelectedShopProps> = ({ shop, onUnselect }) => {
    return (
        <span className="selected-shop">
            <ShopLabel shop={shop} />
            <ButtonIcon
                Component={() => <IconDiscard color="var(--color-neutral-3)" />}
                onClick={() => onUnselect(shop)}
            />
        </span>
    );
}

export default SelectedShop;
